import { AssetType } from '@ocp-zmarta/content-lib'

export default {
  [AssetType.Image]: {
    componentType: 'ZgImage'
  }
}
